import noUiSlider from 'nouislider';

import Base from '../base';

class ProductFiltersSlider extends Base {
	constructor(el, options) {
		super(el, options);

		this.slider = null;

		this.start();
	}

	start() {
		this.render();

		document.body.addEventListener('filter:change', e => this.onChangeFilter(e));
	}

	// Render a 'field' with an empty div which serves as the placeholder for the slider
	render() {
		const field = document.createElement('div');
		const slider = document.createElement('div');

		field.classList.add('field');
		field.appendChild(slider);

		this.el.appendChild(field);

		this.slider = slider;
	}

	createOrUpdateSlider(values) {
		if (this.slider.noUiSlider) {
			this.updateSlider(values);
		} else {
			this.createSlider(values);
			this.addEventListeners();
		}
	}

	createSlider({ MinValue: min, MaxValue: max, StepSize: step }) {
		const {
			inputFrom: { unmaskedValue: from },
			inputTo: { unmaskedValue: to },
		} = this.options;

		noUiSlider.create(this.slider, {
			connect: true,
			range: {
				min,
				max,
			},
			start: [
				from || min,
				to || max,
			],
			step,
		});
	}

	updateSlider({ MinValue: min, MaxValue: max, StepSize: step }) {
		this.slider.noUiSlider.updateOptions({
			range: {
				min,
				max,
			},
			start: [
				min,
				max,
			],
			step,
		});
	}

	addEventListeners() {
		const { from, to } = this.refs;

		// Sync slider values after manual input change
		this.on('change', from);
		this.on('change', to);

		// Sync input values while using the slider
		this.slider.noUiSlider.on('update', (values, handle) => this.setUnmaskedValues(values, handle));
	}

	onChange({ target }) {
		const { inputFrom, inputTo } = this.options;

		if (target === this.refs.from) {
			this.setSliderValues(inputFrom.unmaskedValue, null);

			return;
		}

		this.setSliderValues(null, inputTo.unmaskedValue);
	}

	onChangeFilter({ detail: form }) {
		const isVisible = this.el.hasAttribute('data-is-visible');

		if (!isVisible) {
			return;
		}

		this.getSliderValues(form);
	}

	setUnmaskedValues([from, to], handle) {
		const { inputFrom, inputTo } = this.options;

		if (handle === 0) {
			inputFrom.unmaskedValue = from;

			return;
		}

		inputTo.unmaskedValue = to;
	}

	setSliderValues(from, to) {
		this.slider.noUiSlider.set([from, to], true, true);
	}

	async getSliderValues(form) {
		try {
			const queryString = new URLSearchParams(new FormData(form)).toString();
			const url = `/${this.options.apiBaseUrl}/?${queryString}`;

			const values = await fetch(url).then(res => res.json());

			this.createOrUpdateSlider(values);
		} catch (e) {
			console.warn('error while fetching:', e);
		} finally {
			this.isLoading = false;
		}
	}
}

export default ProductFiltersSlider;
